export class ScreenPresenter {

    constructor(
        private readonly renderHost: RenderHost
    ) {}

    show(
        previous: AppScreen | null,
        next: AppScreen
    ): void {

        previous?.unmount();

        next.mount();

        this.renderHost.showScreen(next);

    }

}